export const LANGUAGE_NAMES = {
    ENGLISH: 'English',
    FRENCH: 'Français',
}

export const en = {
    LANGUAGE_BUTTON_TITLE: LANGUAGE_NAMES.FRENCH,
    PAGE_TITLE: "MyHealthNB - COVID-19 Results",
    LOGOUT_BUTTON_TITLE: "Logout",
    TEST_POSITIVE: "Positive",
    TEST_NEGATIVE: "Negative",
    TEST_PENDING: "Awaiting Result",
    TEST_EQUIVOCAL: "Not Clear",
    NO_RESULT: "Results not in yet",
    ERROR_HOME_LINK: "Retry",
    BASIC_ERROR: "An error occurred",
    TEST_STRING: "ENGLISH TEST",
    FOOTER_TITLE:"New Brunswick",
    GNB_WEBSITE:"https://www.gnb.ca/",
    TOU_LINK: "https://myhealth.gnb.ca/terms-of-use.html",
    PRIVACY_LINK: "https://myhealth.gnb.ca/privacy.html",
    FAQ_LINK: "https://myhealth.gnb.ca/faq.html",
    FAQ: "Frequently Asked Questions",
    FEEDBACK_TXT:"Feedback",
    PRIVACY: "Privacy Statement",
    HELP: "Help",
    TOU: "Terms of Use",
    NB_COPYRIGHT: "All content \u00a9 Government of New Brunswick. All rights reserved.",
    VERSION: "Version - ",
    // Historic Data
    HISTORIC_TEST_HEADER: "Select a test date",
    USERCARD_PARENTAL_ACCESS:"Parental/Guardian Access Only",
    USERCARD_LOGGED_IN: "Logged in as:",
    // Results Box
    RECENT_RESULTS_COMPLETED: "Test Date",
    RECENT_RESULTS_TAKEN: "Taken",
    RECENT_RESULTS_LOCATION: "Location",
    RESULTS_TAG: "Test Result",
    RESULT_BOX_HEADER: "COVID-19 Test Results",
    PENDING_RESULTS: "Pending Result",
    // Info Box
    INFO_BOX_HEADER: " For more information on COVID-19 visit: ",
    INFO_CONTENT: "If your symptoms change or become worse, please contact your health care provider or 811 (Tele-Care) for further directions. ",
    INFO_CONTENT_2: "If your symptoms are severe or life threatening, call 911.",
    // Important Info
    IMPORTANT_INFO_HEADER: "Important Instructions",
    IMPORTANT_SUBTITLE: "At this time, you are still required to self-isolate for the remainder of the 14 days.",
    ISOLATION_TEXT: "We ask that you continue your isolation period of 14 days and monitor yourself as you are still at risk of developing COVID-19.",
    MORE_INFO_TEXT: "For more information on self-isolation, self-monitoring or the Coronavirus visit",
    NO_RESULTS_MESSAGE: "Please note that it may take several days for test results to become available. If you do not see your test result, please check back again in 24 hours",
    // IMPORTANT STEPS
    INFO_POINT_1: "Stay home",
    INFO_POINT_2: "Avoid all close contact with others in your home, especially people with chronic conditions and older adults",
    INFO_POINT_3: "Stay in a separate room away from other people if possible, if not then keep 2 metres or 6 feet from others",
    INFO_POINT_4: "Use a separate bathroom, if possible",
    INFO_POINT_5: "Avoid sharing dishes, glasses, or utensils",
    INFO_POINT_6: "Wash your hands often",
    INFO_POINT_7: "Cough or sneeze into a tissue or your elbow",
    INFO_POINT_8: "Avoid touching your eyes, nose, mouth with your hands",
    TREATMENT_LINK: "https://www2.gnb.ca/content/gnb/en/corporate/promo/covid-19/treatments.html",
    IMPORTANT_PAXLOVID_MESSAGE_1A: "If you test positive for COVID-19 you may be able to access an ",
    IMPORTANT_PAXLOVID_MESSAGE_1B: " anti-viral treatment ",
    IMPORTANT_PAXLOVID_MESSAGE_1C: "(Paxlovid).",
    IMPORTANT_POSITIVE_MESSAGE: "The COVID-19 virus was found.",
    IMPORTANT_NEGATIVE_MESSAGE: "If you have had a known exposure to COVID-19 (travel outside province in last 14 days, contact with a positive case, notified that you were in a place where COVID-19 was spread) then you are required to self-isolate for the full 14 days from the exposure date, even with a negative result.",
    IMPORTANT_NORESULT_MESSAGE: "Please note that it may take several days for test results to become available. If you do not see your test result, please check back again in 24 hours.",
    IMPORTANT_NORESULT_MESSAGE_1: "It may take several days for test results to be processed. If you do not see your test result, please check again.",
    IMPORTANT_NORESULT_MESSAGE_2: "Please continue to follow the instructions to self-isolate you were given by your health care provider or the COVID assessment center staff.",
    POPUP_NEGATIVE_MESSAGE_1: "COVID-19 virus not found at this time.",
    POPUP_NEGATIVE_MESSAGE_2: "Visit the ",
    POPUP_NEGATIVE_MESSAGE_3: "GNB COVID-19 website",
    POPUP_NEGATIVE_MESSAGE_4: " for the most up-to-date information and guidance on COVID-19.",
    IMPORTANT_NEGATIVE_INFO_LINK: "https://www2.gnb.ca/content/gnb/en/corporate/promo/covid-19/self_isolation.html",
    POPUP_EQUIVOCAL_MESSAGE_1: "Your COVID-19 test result shows the virus may have been found.",
    POPUP_EQUIVOCAL_MESSAGE_2: "Further tests are being done which may take a few days.",
    POPUP_EQUIVOCAL_MESSAGE_3: "Please self-isolate yourself at home and wait for a call from Public Health.",
    IMPORTANT_NO_RESULTS_MESSAGE_1:"Your test results are not back yet.",
    IMPORTANT_NO_RESULTS_MESSAGE_3:"It may take up to 72 hours (or longer) depending on testing volume for COVID-19 test results to become available. If you do not see your test results, please check again by clicking on the ",
    IMPORTANT_NO_RESULTS_MESSAGE_4:"Refresh Results ",
    IMPORTANT_NO_RESULTS_MESSAGE_5:"button periodically or logging out and checking again later by logging back in.",
    IMPORTANT_NO_RESULTS_MESSAGE_6:"Visit the ",
    IMPORTANT_NO_RESULTS_MESSAGE_7:"GNB COVID-19 website",
    IMPORTANT_NO_RESULTS_MESSAGE_8:" for the most up-to-date information and guidance on COVID-19.",
    POPUP_NORESULTS_MESSAGE_1: "Your test results are not back yet. ",
    POPUP_NORESULTS_MESSAGE_2: "While waiting for your test result, please continue to follow the instructions to self-isolate that you were given by your health care provider or the COVID assessment centre staff.",
    POPUP_NORESULTS_MESSAGE_3: "Please check again.",
    POPUP_NORESULTS_MESSAGE_4: "Refer to the",
    POPUP_NORESULTS_MESSAGE_5: "Important Instructions ",
    POPUP_NORESULTS_MESSAGE_6: "on the results page for what to do next.",
    IMPORTANT_EQUIVOCAL_MESSAGE: "Your COVID-19 test result shows the virus may have been found.",
    IMPORTANT_EQUIVOCAL_MESSAGE_2: "Further tests are being done which may take a few days.",
    IMPORTANT_EQUIVOCAL_MESSAGE_3: "For the most up-to-date information and guidance on COVID-19, see the ",
    IMPORTANT_EQUIVOCAL_MESSAGE_4: "GNB COVID-19 website.",
    IMPORTANT_NEGATIVE_BULLETS_HEADER: "Therefore:",
    IMPORTANT_NORESULT_BULLETS_HEADER: "Therefore:",
    IMPORTANT_EQUIVOCAL_BULLETS_HEADER: "Please self-isolate yourself at home and wait for a call from Public Health.",
    IMPORTANT_NEGATIVE_ADDITIONAL_MESSAGE: "If you have no known exposure to COVID-19 (you didn’t travel, you have not been in contact with a positive case or been notified that you were in a place where COVID-19 was spread), then you need to stay home until you feel better.",
    IMPORTANT_NEGATIVE_ADDITIONAL_BULLETS_HEADER: "Continue to do the following:",
    IMPORTANT_NEGATIVE_FINAL_MESSAGE: "If you are a health care worker or work at a nursing home, group living facility or hospital, please check with your employer before returning to work",
    MISSING_IDENTIFIER_MESSAGE: "Digital Identifier not found for member",
    AUTHENTICATION_REQUIRED_MESSAGE: "Failed to authenticate",
    NO_ID_MESSAGE: "No source id in request",
    UNKNOWN_ERROR_MESSAGE: "Unknown error",
    HIAL804_ERROR_MESSAGE: "ERROR 804 - A problem has been encountered, please contact Support at 1-844-462-8387.",
    HIAL806_ERROR_MESSAGE: "ERROR 806 - ",
    HIAL904_ERROR_MESSAGE: "ERROR 904 - A problem has been encountered, please contact Support at 1-844-462-8387.",
    HIAL905_ERROR_MESSAGE: "ERROR 905 - No Vaccinations Currently Available - It can take up to 5 days before a vaccination record is processed and show up in MyHealthNB. If you are still having trouble, please contact Support at 1-844-462-8387.",
    HIAL906_ERROR_MESSAGE: "ERROR 906 - ",
    HIAL907_ERROR_MESSAGE: "No QR code was found in the Public Health Information System (PHIS) for the vaccination record(s) on file. A correction to the record(s) may be required. See the MyHealthNB FAQs (myhealth.gnb.ca/faq.html) for further information.",
    HIAL999_ERROR_MESSAGE: "ERROR 999 - Sorry, we are experiencing technical difficulties, please try back later.",
    ACCESS_DENIED_MESSAGE: "Access denied",
    GATEWAY_NETWORK_ERROR: "Connection Failed",
    DATA_ACCESS_MESSAGE: "An internal error occurred while connecting to health data provider",
    SESSION_TIMEOUT_MESSAGE: "Your session has timed out",
    ERROR_HEADER: "Error",
    ERROR_PREFIX: "An error occurred. Click the Retry button or click \"Home\" on the menu bar to return to the MyHealthNB Portal",
    MODAL_ACCEPT_BUTTON_LABEL: "OK",
    // Results Box
    ICON_WASHHANDS: "Wash hands often for 20 sec",
    ICON_TOUCHFACE: "Do not touch your face",
    ICON_COUGH: "Cough and sneeze in elbow or tissue",
    ICON_DISTANCING: "Keep 2 m or 6 ft apart",
    SESSION_TIMEOUT_ERROR: "This page has expired and you have been logged out.  Please click the Login button and enter your email and password to log in again to access your test results.",
    SESSION_TIMEOUT_ERROR_HEADER: "Page Expired",
    TWO_WEEKS_OLD: "Your most recent test result is more than 2 weeks old.",
    // Error Messages
    REG_ERROR_INVALID_REGISTRATION_NUMBER: "Registration Code is required",
    REG_ERROR_INVALID_MEDICARE_NUMBER: "Medicare Number is required",
    REG_ERROR_INVALID_EXPIRATION_DATE: "Expiry month is required",
    REG_ERROR_INVALID_EXPIRATION_MONTH: "Expiry month must be between 1 and 12",
    REG_ERROR_INVALID_EXPIRATION_YEAR: "Expiry year is required",
    REG_ERROR_INVALID_FIRST_NAME: "First Name is required",
    REG_ERROR_INVALID_LAST_NAME: "Last Name is required",
    REG_ERROR_INVALID_NAME: "Only characters are allowed",
    REG_ERROR_INVALID_DOB: "This child is 16 or older and must create their own MyHealthNB account.",
    REG_ERROR_MISSING_DOB: "Date of Birth is required",
    REG_ERROR_INVALID_DOB_DAY: "Date is required",
    REG_ERROR_INVALID_DOB_MONTH: "Month is required",
    REG_ERROR_INVALID_DOB_YEAR: "Year is required",
    // Dependent Screen Labels
    DEPENDENT_BOX_HEADER: "Add a Child (under 16)",
    DEPENDENT_PAGE_HEADER: "Add Child's Information for Verification",
    DEPENDENT_REG_CODE_LABEL: "Enter your child's Registration Code",
    DEPENDENT_REG_CODE_SUB_LABEL: "This must be a code for your child (under 16)",
    DEPENDENT_REG_CODE_PLACEHOLDER: "ENTER CODE",
    DEPENDENT_ISSUER_LABEL: "Health Card Issuer",
    DEPENDENT_ISSUER_NB: "NEW BRUNSWICK",
    DEPENDENT_PHIN_LABEL:"Medicare Number",
    DEPENDENT_PHIN_PLACEHOLDER:"999 999 999",
    DEPENDENT_FIRST_NAME_LABEL: "First Name",
    DEPENDENT_FIRST_NAME_PLACEHOLDER: "FIRST NAME",
    DEPENDENT_LAST_NAME_LABEL: "Last Name",
    DEPENDENT_LAST_NAME_PLACEHOLDER: "LAST NAME",
    DEPENDENT_EXPIRATION_LABEL: "Expiry Date",
    DEPENDENT_DAY: "DD",
    DEPENDENT_MONTH: "MM",
    DEPENDENT_YEAR: "YYYY",
    DEPENDENT_DOB_LABEL: "Date of Birth",
    DEPENDENT_SUBMIT_BUTTON: "Submit",
    DEPENDENT_CANCEL_BUTTON: "Cancel",
    DEPENDENT_AGREE_BUTTON: "I agree",
    DEPENDENT_AGREEMENT_MESSAGE: "By clicking “I agree”, you confirm that:",
    DEPENDENT_AGREEMENT_BULLET_1: "you are a parent/guardian of a child (under 16) and have the right to access this child’s COVID-19 results",
    DEPENDENT_AGREEMENT_BULLET_2: "are not the subject of any measures that would make you a parent/guardian with no right of access to information about this child",
    DEPENDENT_AGREEMENT_BULLET_3: "understand that access to information in your capacity of a parent, guardian of a child (under 16) is restricted to COVID-19 results on MyHealthNB.",
    // Child Reg Info Card
    REG_INFO_LABLE: "Add a Child (under 16)",
    REG_INFO_MESSAGE_1: "A parent/guardian may add a child if they are less than 16 years old.",
    REG_INFO_MESSAGE_2: "When a child reaches the age of 16, access to their results will no longer be available.",
    REG_INFO_MESSAGE_3: "If the child you are adding is 16 or older they must register for their own MyHealthNB account.",
    PARENTAL_ACCESS_ALERT_HEADER: "Parental/Guardian Access Only",
    PARENTAL_ACCESS_ALERT_BODY: "You have an account but have not provided your own registration code. This gives you ",
    PARENTAL_ACCESS_ALERT_BODY_2: "Parental/Guardian Access only.",
    PARENTAL_ACCESS_ALERT_BODY_3: " You are able to add your child(ren)’s (under 16) personal health information and view their ",
    PARENTAL_ACCESS_ALERT_BODY_3_1: "COVID-19 information.",
    PARENTAL_ACCESS_ALERT_BODY_4: "If you have been tested and/or vaccinated against COVID-19 go ",
    PARENTAL_ACCESS_ALERT_BODY_5: "here ",
    PARENTAL_ACCESS_ALERT_BODY_6:"and click Manage my account to increase your access level and view your own COVID-19 information.",
    PARENTAL_ACCESS_ALERT_ADD_ACCESS: "Add Access",
    ADD_CHILD_BTTN: "Add a child (under 16)",
    VIEW_RESULTS: "View Results",
    IMMUNIZATION_RECORD: "View Vaccinations",
    INVALID_DEPENDANT_ERROR: "This child is 16 or older and must create their own MyHealthNB Account.",
    // Registration Error Messages
    REG_ERROR_INVALID_ITEM: "Registration failed: Invalid item",
    REG_ERROR_CREATE_USER: "Registration failed: Could not create user",
    REG_ERROR_MESSAGE: "Registration failed",
    REG_ERROR_STANDARD: "Error registering...",
    REFRESH_RESULTS:"Refresh Results",
    INCREASE_ACCESS_BUTTON_TEXT:"Increase My Access Level",
    PARENTAL_ACCESS_RESULT_BOX_HEADER: "COVID-19 Homepage",
    BACK_TO_HOME: "Back to Home",
    VIEW_YOUR_RESULTS_HEADER:"To View Your Results",
    VIEW_YOUR_RESULTS_BODY:"New test dates will display as soon as the result is available",
    VIEW_YOUR_RESULTS_BODY_2:"Please note that it may take several days for test results to become available. If you do not see your test result, please check again later.",
    VIEW_YOUR_RESULTS_BODY_3:"You may click the “Refresh Results” button to check for updates.",
    VIEW_YOUR_RESULTS_BODY_4: "To view the results of previous test, click the test date dropdown and choose the test date for results you wish to view.",

    REG_ERROR_REG_NUM: "Sorry, something went wrong with checking your child’s Registration Code.  Please verify the information you entered and try again.  Still having trouble? Contact Support.",
    REG_ERROR_ISSUER: "Only individuals with a NB Medicare number are currently eligible to register for a MyHealthNB account.",
    REG_ERROR_HCN_MISSING: "Sorry, something went wrong with checking your child’s New Brunswick Medicare number. Please verify the information you entered and try again.   Still having trouble? Contact Support.",
    REG_ERROR_LAST_NAME: "Sorry, something went wrong with checking your child’s name.  Please verify the information you entered and try again. Still having trouble? Contact Support.",
    REG_ERROR_EXPIRY: "Sorry, something went wrong with checking your child’s Medicare Expiry Date.  Please verify the information you entered and try again. Still having trouble? Contact Support.",
    REG_ERROR_DOB: "Sorry, something went wrong with checking your child’s Date of Birth.  Please verify the information you entered and try again. Still having trouble? Contact Support.",
    REG_ERROR_DOB_U16: "Dependents 16 years of age or older must register for their own MyHealthNB account",
    REG_ERROR_READD_CHILD: "This child has already been added to your account",
    REG_ERROR_MEDICARE_FIELD_NOT_ENOUGH_DIGITS: "Medicare Number Length should be 9 digits",
    REG_POPUP_HEADER: "Cancel Add Child (under 16)",
    REG_POPUP_MESSAGE: "Do you want to cancel adding a child (under 16)?",
    REG_POPUP_CANCEL: "No",
    REG_POPUP_CONFIRM: "Yes",
    ERROR: "Error",
    REG_ERROR_CHECKBOX_ERROR: "Kindly agree to terms of use to proceed.",
    REG_ERROR_DOB_DAY_OUT_OF_RANGE: "Date of birth day must be between 1 and 31",
    REG_ERROR_DOB_MONTH_OUT_OF_RANGE: "Date of birth month must be between 1 and 12",
    MEDICARE: "Health Card Number",
    IMPORTANT_POSITIVE_MESSAGE_1: "Visit the",
    IMPORTANT_POSITIVE_MESSAGE_1B: " GNB COVID-19 website ",
    IMPORTANT_POSITIVE_MESSAGE_1C: "for the most up-to-date instructions and guidance on COVID-19.",
    COVID_MAIN_PAGE_LINK: "https://www2.gnb.ca/content/gnb/en/corporate/promo/covid-19.html",
    SELF_ISOLATION_LINK: "https://www2.gnb.ca/content/gnb/en/corporate/promo/covid-19/self_isolation.html",
    DOWNLOAD_PDF:"Print PDF",
    PDF_CONFIRM_HEADER:"Notice",
    PDF_CONFIRM_MESSAGE_1:"Users should be aware that in order ",
    PDF_CONFIRM_MESSAGE_2:"to ensure the highest standard of authenticity and allow for the printing of an official copy of a COVID-19 test result, ",
    PDF_CONFIRM_MESSAGE_3:"MyHealthNB receives and makes available for printing by its users, medical information (test results) in the language and as issued directly by the lab which provided it.",
    PDF_POPUP_CONFIRM:"OK",
    PDF_POPUP_CANCEL:"Cancel",
    HCN_ISSUER: {
        NB:"NB",
        NS:"NS",
        DND:"DND",
        PE:"PE",
        NL:"NL",
        QC:"QC",
        AB:"AB",
        BC:"BC",
        CSC:"CSC",
        CA:"CA",
        INAC:"INAC",
        MB:"MB",
        NT:"NT",
        NU:"NU",
        ON:"ON",
        RCMP:"RCMP",
        SK:"SK",
        YT:"YT",
        DVA:"DVA",
    },

    // IMMUNIZATION RECORD
    IMMUNIZATIONS_HEADER: "COVID-19 Immunization Record",
    INVALID_IMMUNIZATION_DESC_1: "Invalid immunization phrase 1",
    BACK_BUTTON_TEXT: "Back to Home",
    BACK_TEXT: "Back",
    PRINT_BUTTON: "NB Immunization Record",
    PRINT_VAX_BUTTON: "Canadian Proof of Vaccination",
    VACCINE_PASSPORT: "Vaccination Status",
    VACCINE_PASSPORT_USE_NB: "For use in NB",
    IMMUNIZATIONS_NO_RESULTS_DESC: "NO VACCINATIONS CURRENTLY AVAILABLE",
    IMMUNIZATIONS_SIDE_ALERT_1_1: "This is an online record of your COVID-19 immunization. The paper ",
    IMMUNIZATIONS_SIDE_ALERT_1_2: "Record of COVID-19 Immunization",
    IMMUNIZATIONS_SIDE_ALERT_1_3: " provided at the time of your vaccination is your official record.",
    IMMUNIZATIONS_SIDE_ALERT_2: "It may take up to five business days for immunization records to be processed.  Your COVID-19 vaccination will appear in the list once it becomes available.",
    IMMUNIZATIONS_SIDE_ALERT_3: "For the most up-to-date COVID-19 information, we recommend that you visit the ",
    IMMUNIZATIONS_SIDE_ALERT_3_LINK_TEXT: "GNB website",
    IMMUNIZATIONS_SIDE_ALERT_3_LINK: " https://www2.gnb.ca/content/gnb/en/corporate/promo/covid-19.html",
    IMMUNIZATIONS_SIDE_ALERT_3_2: ".",
    IMMUNIZATIONS_BOTTOM_ALERT_1: "This information is provided by the Government of New Brunswick's provincial immunization registry in the Public Health Information Solution (PHIS). ",
    IMMUNIZATIONS_BOTTOM_ALERT_2: "For more information, visit ",
    IMMUNIZATIONS_BOTTOM_ALERT_3: "Public Health.",
    IMMUNIZATIONS_BOTTOM_ALERT_LINK: "https://www2.gnb.ca/content/gnb/en/departments/ocmoh/cdc/content/PHIS.html",
    IMMUNIZATIONS_RESULTS_VACCINE_NAME: "VACCINE NAME",
    IMMUNIZATIONS_RESULTS_VACCINE_TYPE: "VACCINE TYPE",
    IMMUNIZATIONS_RESULTS_VACCINE_DATE_1: "DATE",
    IMMUNIZATIONS_RESULTS_VACCINE_DATE_2: "(YYYY-MM-DD)",
    DEFAULT_SUPPORT_ERROR: "Sorry, something went wrong. Contact Support at ",
    DEFAULT_SUPPORT_ERROR_PHONE: "1-844-462-8387",
    HIAL_DEFAULT_ERROR: "Sorry, we are experiencing technical difficulties, please try back later.",

    // VACCINE PASSPORT
    VACCINE_PASSPORT_HEADER: "COVID-19 Vaccination Status",
    VACCINE_PASSPORT_DOB: "Date of Birth: ",
    VACCINATION_STATUS: "VERIFIED",
    VACCINATION_STATUS_NA: "UNABLE TO VERIFY",
    VACCINATED_TEXT_ISSUED: "Issued on: ",
    VACCINATION_X_NOTE_1: "It may take up to 5 days for your vaccination to be processed and your status to be updated.",
    VACCINATION_X_NOTE_2: "In the meantime, the paper Record of COVID-19 Immunization you received when you were vaccinated is an official record and an accepted proof of vaccination.",

    PDF_ERROR_MESSAGE: "A problem has been encountered, please contact Support at 1-844-462-8387.",
    PVC_PDF_FILENAME: "Canadian_Proof_of_COVID-19_Vaccination_",
    QRCE_ERROR_MESSAGE: "A problem has been encountered, please contact Support at 1-844-462-8387.",
    IIABE_ERROR_MESSAGE: "A problem has been encountered, please contact Support at 1-844-462-8387.",
    SFEE_ERROR_MESSAGE: "Sorry, something went wrong. Contact Support at 1-844-462-8387",

    // TERMS OF USE SCREEN
    TERMS_OF_USE_PAGE_NAME: "Terms of Use for MyHealthNB COVID-19 application",
    TERMS_OF_USE_APP_NAME: "MyHealthNB COVID-19",
    TERMS_OF_USE_APP_DISCLAIMER_OPTIONAL_1: "These are the terms of use each user must read and accept before creating a new account, logging in for the first time, or after the terms of use have been changed. ",
    TERMS_OF_USE_APP_DISCLAIMER_OPTIONAL_2: "You do not need to accept the terms of use here, they are displayed in this page for your information only.",
    TERMS_OF_USE_LOGIN_DISCLAIMER_1: "Before you can login to the ",
    TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_1: "The terms of use have changed as of ",
    TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_2: "November 21, 2022",
    TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_3: ".  Before you can login to the ",
    TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_4: " application and access your personal health information, you must read and accept all of the statements (terms of use) below and agree that you:",
    TERMS_OF_USE_LOGIN_DISCLAIMER_2: " application to access your COVID-19 test results, COVID-19 Immunization Record, and important COVID-19 instructions and information, you must read and accept all of the statements (terms of use) below and agree that you:",
    TERMS_OF_USE_ITEM_1: "will not use the services in a way that could hurt others or the system itself",
    TERMS_OF_USE_ITEM_2: "recognize that you are always responsible for your login information (i.e. username, password) even if you change it",
    TERMS_OF_USE_ITEM_3: "will keep your login information for yourself and will not share it with others",
    TERMS_OF_USE_ITEM_4: "will contact us immediately at 1-844-462-8387 if you think your login information has been used by someone other than you",
    TERMS_OF_USE_ITEM_5: "will not use your own or someone else’s login information for any illegal or improper purposes",
    TERMS_OF_USE_ITEM_6_1: "accept that eHealthNB audits and monitors accesses to the ",
    TERMS_OF_USE_ITEM_6_2: " application",
    TERMS_OF_USE_ITEM_7_1: "accept that your ",
    TERMS_OF_USE_ITEM_7_2: " access may be suspended or cancelled if inappropriately used",
    TERMS_OF_USE_ITEM_8_1: "accept that Public Health will be able to verify that you have accessed your COVID-19 test results and/or immunization records via the ",
    TERMS_OF_USE_ITEM_8_2: " application",
    TERMS_OF_USE_ITEM_9_1: " accept that, when available, access to a child’s information who is under 16 and under your legal custody will be restricted to their COVID-19 information accessible via the ",
    TERMS_OF_USE_ITEM_9_2: " application",
    TERMS_OF_USE_ITEM_10_1: "will not use the services to access your child's aged 16 and over COVID-19 test results and/or COVID-19 Immunization Record accessible via the ",
    TERMS_OF_USE_ITEM_10_2: " application",
    TERMS_OF_USE_ITEM_11_1: "accept that Public Health will be able to verify that, when available, you have accessed a child’s under 16 COVID-19 test results and/or COVID-19 Immunization Record in your capacity as their parent/guardian via the ",
    TERMS_OF_USE_ITEM_11_2: " application",
    TERMS_OF_USE_ACCEPT_BUTTON: "Accept",
    TERMS_OF_USE_CANCEL_BUTTON: "Cancel",

    TERMS_OF_USE_SIDE_LINK_1: "MyHealthNB COVID-19 ",
    TERMS_OF_USE_SIDE_LINK_2: "Terms of Use",
    TERMS_OF_USE_SIDE_LINK_3: ".",
}

export const fr = {
    LANGUAGE_BUTTON_TITLE: LANGUAGE_NAMES.ENGLISH,
    PAGE_TITLE: "MaSantéNB - COVID - 19 Résultats",
    LOGOUT_BUTTON_TITLE: "Quitter",
    TEST_POSITIVE: "Positif",
    TEST_NEGATIVE: "Négatif",
    TEST_PENDING: "En attente du résultat",
    TEST_EQUIVOCAL: "Pas clair",
    NO_RESULT: "Résultat pas encore revenu",
    ERROR_HOME_LINK: "Réessayer",
    BASIC_ERROR: "Une erreur est survenue",
    TEST_STRING: "FRENCH TEST",
    FOOTER_TITLE:"Nouveau Brunswick",
    GNB_WEBSITE:"https://www.gnb.ca/",
    TOU_LINK: "https://masante.gnb.ca/conditions-dutilisation.html",
    PRIVACY_LINK: "https://masante.gnb.ca/declaration-de-confidentialite.html",
    FAQ_LINK: "https://masante.gnb.ca/foire-aux-questions.html",
    //
    FAQ: "Foire aux questions",
    FEEDBACK_TXT:"Feedback",
    PRIVACY: "Déclaration de confidentialité",
    HELP: "Aider",
    TOU: "Conditions d'utilisation",
    NB_COPYRIGHT: "Tout le contenu \u00a9 Le gouvernement du Nouveau-Brunswick. Tous droits réservés.",
    VERSION: "Version - ",
    // Historic Data
    HISTORIC_TEST_HEADER: "Sélectionner une date de test",
    USERCARD_PARENTAL_ACCESS:"Accès parental uniquement",
    USERCARD_LOGGED_IN: "Connecté en tant que :",
    // Results Box
    RECENT_RESULTS_COMPLETED: "Date du test",
    RECENT_RESULTS_TAKEN: "Pris",
    RECENT_RESULTS_LOCATION: "Lieu",
    RESULTS_TAG: "Résultat du test",
    RESULT_BOX_HEADER: "Résultats du test COVID-19",
    PENDING_RESULTS: "Résultats en attente",
    // Info Box
    INFO_BOX_HEADER: "Pour plus d'informations sur COVID-19, visitez : ",
    INFO_CONTENT: "Si vos symptômes changent ou s'aggravent, veuillez contacter votre prestataire de soins de santé ou le 811 (Télé-Soins) pour obtenir des instructions supplémentaires. ",
    INFO_CONTENT_2: "Si vos symptômes sont graves ou mettent votre vie en danger, appelez le 911.",
    // Important Info
    IMPORTANT_INFO_HEADER: "Instructions importantes",
    IMPORTANT_SUBTITLE: "À ce moment, vous devez toujours vous auto-isoler pour le reste des 14 jours.",
    ISOLATION_TEXT: "Nous vous demandons de poursuivre votre période d'isolement de 14 jours et de vous examiner car vous êtes toujours à risque de développer le COVID-19.",
    MORE_INFO_TEXT: "Pour plus d'informations sur l'auto-isolement, l'auto-surveillance ou le Coronavirus consultez",
    NO_RESULTS_MESSAGE: "Veuillez noter que les résultats des tests peuvent prendre plusieurs jours avant d'être disponibles. Si vous ne voyez pas le résultat de votre test, veuillez réessayer dans 24 heures",
    // IMPORTANT STEPS
    INFO_POINT_1: "Restez à la maison",
    INFO_POINT_2: "Évitez tout contact étroit avec d'autres personnes à votre domicile, en particulier les personnes souffrant de maladies chroniques et les personnes âgées.",
    INFO_POINT_3: "Restez dans une chambre séparée, si possible, sinon restez à 2 mètres ou 6 pieds des autres personnes.",
    INFO_POINT_4: "Utilisez une salle de bain séparée, si possible.",
    INFO_POINT_5: "Évitez de partager la vaisselle, les verres ou les ustensiles.",
    INFO_POINT_6: "Lavez-vous souvent les mains",
    INFO_POINT_7: "Toussez ou éternuez dans un mouchoir en papier ou dans votre coude",
    INFO_POINT_8: "Évitez de toucher vos yeux, votre nez et votre bouche avec vos mains",
    TREATMENT_LINK: "https://www2.gnb.ca/content/gnb/fr/corporate/promo/covid-19/traitements.html",
    IMPORTANT_PAXLOVID_MESSAGE_1A: "Si votre test est positif pour le COVID-19, vous pourrez peut-être avoir accès à un ",
    IMPORTANT_PAXLOVID_MESSAGE_1B: " traitement antiviral ",
    IMPORTANT_PAXLOVID_MESSAGE_1C: "(Paxlovid).",
    IMPORTANT_POSITIVE_MESSAGE: "Le virus COVID-19 a été détecté.",
    IMPORTANT_NEGATIVE_MESSAGE: "Si vous avez eu une exposition connue à COVID-19 (voyage hors de la province au cours des 14 derniers jours, contact avec un cas positif, notification que vous étiez dans un endroit où COVID-19 a été répandu), vous êtes tenu de vous isoler pendant les 14 jours complets à partir de la date d'exposition, même avec un résultat négatif.",
    IMPORTANT_NORESULT_MESSAGE: "Veuillez noter qu'il peut s'écouler plusieurs jours avant que les résultats des tests ne soient disponibles. Si vous ne voyez pas le résultat de votre test, veuillez vérifier à nouveau dans les 24 heures.",
    IMPORTANT_NORESULT_MESSAGE_1: "Le traitement des résultats des tests peut prendre plusieurs jours. Si vous ne voyez pas le résultat de votre test, veuillez vérifier à nouveau.",
    IMPORTANT_NORESULT_MESSAGE_2: "Veuillez continuer à suivre les instructions d'auto-isolation qui vous ont été données par votre professionnel de soins de santé ou le personnel du centre d'évaluation COVID.",
    POPUP_NEGATIVE_MESSAGE_1: "Le virus COVID-19 n'a pas été détecté à ce moment.",
    POPUP_NEGATIVE_MESSAGE_2: "Visitez ",
    POPUP_NEGATIVE_MESSAGE_3: "le site web de GNB COVID-19",
    POPUP_NEGATIVE_MESSAGE_4: " pour les renseignements et les directives de la COVID-19 à jour.",
    IMPORTANT_NEGATIVE_INFO_LINK: "https://www2.gnb.ca/content/gnb/fr/corporate/promo/covid-19/auto_isolement.html",
    POPUP_EQUIVOCAL_MESSAGE_1: "Le résultat de votre test COVID-19 montre que le virus a peut-être été détecté.",
    POPUP_EQUIVOCAL_MESSAGE_2: "D'autres tests sont en cours, ce qui peut prendre quelques jours.",
    POPUP_EQUIVOCAL_MESSAGE_3: "Veuillez vous isoler chez vous et attendre un appel de la Santé publique.",
    IMPORTANT_NO_RESULTS_MESSAGE_1:"Les résultats de vos tests ne sont pas encore revenus.",
    IMPORTANT_NO_RESULTS_MESSAGE_3:"Le traitement des résultats des tests peut s’écouler jusqu’à 72 heures (ou plus) selon le volume des tests effectués avant que les résultats d’un test COVID-19 ne soient disponibles. Si vous ne voyez pas les résultats de votre test, veuillez vérifier à nouveau en cliquant régulièrement sur le bouton ",
    IMPORTANT_NO_RESULTS_MESSAGE_4:"Rafraîchir les résultats ",
    IMPORTANT_NO_RESULTS_MESSAGE_5:"ou en fermant votre session et en ouvrant une autre session plus tard pour vérifier à nouveau.",
    IMPORTANT_NO_RESULTS_MESSAGE_6:"Consultez les renseignements et les directives de la COVID-19 à jour au ",
    IMPORTANT_NO_RESULTS_MESSAGE_7:"site web de GNB COVID-19.",
    IMPORTANT_NO_RESULTS_MESSAGE_8:"",
    POPUP_NORESULTS_MESSAGE_1: "Les résultats de vos tests ne sont pas encore revenus.",
    POPUP_NORESULTS_MESSAGE_2: "En attendant le résultat de votre test, veuillez continuer à suivre les instructions d'auto-isolation qui vous ont été données par votre professionnel de soins de santé ou le personnel du centre d'évaluation COVID.",
    POPUP_NORESULTS_MESSAGE_3: "Veuillez vérifier à nouveau.",
    POPUP_NORESULTS_MESSAGE_4: "Consultez les ",
    POPUP_NORESULTS_MESSAGE_5: "instructions importantes ",
    POPUP_NORESULTS_MESSAGE_6: "sur la page des résultats pour savoir ce qu'il faut faire ensuite.",
    IMPORTANT_EQUIVOCAL_MESSAGE: "Le résultat de votre test COVID-19 montre que le virus a peut-être été détecté.",
    IMPORTANT_EQUIVOCAL_MESSAGE_2: "D'autres tests sont en cours, qui peuvent prendre quelques jours.",
    IMPORTANT_EQUIVOCAL_MESSAGE_3: "Consultez les renseignements et les directives de la COVID-19 à jour au ",
    IMPORTANT_EQUIVOCAL_MESSAGE_4: "site web de GNB COVID-19.",
    IMPORTANT_NEGATIVE_BULLETS_HEADER: "Par conséquent:",
    IMPORTANT_NORESULT_BULLETS_HEADER: "Par conséquent:",
    IMPORTANT_EQUIVOCAL_BULLETS_HEADER: "Veuillez vous isoler à la maison et attendre un appel de la Santé publique.",
    IMPORTANT_NEGATIVE_ADDITIONAL_MESSAGE: "Si vous n'avez aucune exposition connue à COVID-19 (vous n'avez pas voyagé, vous n'avez pas été en contact avec un cas positif ou on vous a notifié que vous étiez dans un endroit où COVID-19 était répandu), alors vous devez rester chez vous jusqu'à ce que vous vous sentiez mieux.",
    IMPORTANT_NEGATIVE_ADDITIONAL_BULLETS_HEADER: "Continuez à faire ce qui suit:",
    IMPORTANT_NEGATIVE_FINAL_MESSAGE: "Si vous êtes un travailleur de la santé ou si vous travaillez dans un foyer de soins, un établissement résidentiel ou un hôpital, veuillez vérifier auprès de votre employeur avant de retourner au travail.",
    MISSING_IDENTIFIER_MESSAGE: "Identifiant numérique non trouvé pour le membre",
    AUTHENTICATION_REQUIRED_MESSAGE: "Pas d'authentification",
    NO_ID_MESSAGE: "Pas d'identification de la source dans la demande",
    UNKNOWN_ERROR_MESSAGE: "Erreur inconnue",
    HIAL804_ERROR_MESSAGE: "ERREUR 804 - Un problème technique est survenu. Veuillez contacter l'équipe de soutien au 1-844-462-8387.",
    HIAL806_ERROR_MESSAGE: "ERREUR 806 - ",
    HIAL904_ERROR_MESSAGE: "ERREUR 904 - Un problème technique est survenu. Veuillez contacter l'équipe de soutien au 1-844-462-8387.",
    HIAL905_ERROR_MESSAGE: "ERREUR 905 - Actuellement, il n'y a aucun vaccinations disponible - Le traitement des dossiers de vaccination peut prendre jusqu’à cinq jours ouvrables. Le dossier s’ajoutera à MaSantéNB quand il soit traité. Vous avez encore des problèmes ? Contactez l'assistance au 1-844-462-8387.",
    HIAL906_ERROR_MESSAGE: "ERREUR 906 - ",
    HIAL907_ERROR_MESSAGE: "Aucun code QR n’a été trouvé dans la Solution d’information sur la santé publique (SISP) pour le(s) document(s) de vaccination figurant au dossier. Une correction au(x) document(s) pourrait être nécessaire. Pour de plus amples renseignements, veuillez consulter la Foire aux questions de MaSantéNB (masante.gnb.ca/foire-aux-questions.html).",
    HIAL999_ERROR_MESSAGE: "ERREUR 999 - Désolé, mais nous éprouvons des difficultés techniques. S’il vous plaît essayer à nouveau plus tard.",
    ACCESS_DENIED_MESSAGE: "Accès refusé",
    GATEWAY_NETWORK_ERROR: "La connexion a échoué",
    DATA_ACCESS_MESSAGE: "Une erreur interne s'est produite lors de la connexion au fournisseur de données de santé",
    SESSION_TIMEOUT_MESSAGE: "Votre session a expirée",
    ERROR_HEADER: "Erreur",
    ERROR_PREFIX: "Une erreur s'est produit. Cliquez le bouton Réessayer ou sur « Accueil » dans la barre de menus pour retourner au portail MaSantéNB.",
    MODAL_ACCEPT_BUTTON_LABEL: "Ok",
    // Results Box
    ICON_WASHHANDS: "Se laver les mains souvent pendant 20 secondes",
    ICON_TOUCHFACE: "Ne touchez pas votre visage",
    ICON_COUGH: "Toussez et éternuez dans le coude ou mouchoir",
    ICON_DISTANCING: "Gardez une distance de 2 m. ou 6 pi.",
    SESSION_TIMEOUT_ERROR: "Cette page a expiré et vous avez été déconnecté.  Veuillez cliquer sur le bouton \"Se connecter\" et entrer votre adresse courriel et votre mot de passe pour vous reconnecter et accéder à vos résultats de test.",
    SESSION_TIMEOUT_ERROR_HEADER: "Page expirée",
    TWO_WEEKS_OLD: "Votre dernier résultat de test affiché date de plus de 2 semaines.",
    // Error Messages
    REG_ERROR_INVALID_REGISTRATION_NUMBER: "Le code d'inscription est obligatoire",
    REG_ERROR_INVALID_MEDICARE_NUMBER: "Le numéro d'assurance-maladie est requis",
    REG_ERROR_INVALID_EXPIRATION_DATE: "Le mois d’expiration est obligatoire",
    REG_ERROR_INVALID_EXPIRATION_MONTH: "Le mois d’expiration doit être compris entre 1 et 12",
    REG_ERROR_INVALID_EXPIRATION_YEAR: "L’année d’expiration est obligatoire",
    REG_ERROR_INVALID_FIRST_NAME: "Le prénom est requis",
    REG_ERROR_INVALID_LAST_NAME: "Le nom est obligatoire",
    REG_ERROR_INVALID_NAME: "Seuls les caractères sont autorisés",
    REG_ERROR_INVALID_DOB: "Cet enfant a 16 ans ou plus et doit créer son propre compte MaSantéNB.",
    REG_ERROR_MISSING_DOB: "La date de naissance est obligatoire",
    REG_ERROR_INVALID_DOB_DAY: "La date est obligatoire",
    REG_ERROR_INVALID_DOB_MONTH: "Le mois est requis",
    REG_ERROR_INVALID_DOB_YEAR: "L'année est obligatoire",
    // Dependent Screen Labels
    DEPENDENT_BOX_HEADER: "Ajouter un enfant (moins de 16 ans)",
    DEPENDENT_PAGE_HEADER: "Ajouter les informations de l'enfant pour vérification",
    DEPENDENT_REG_CODE_LABEL: "Entrez le code d’inscription de votre enfant",
    DEPENDENT_REG_CODE_SUB_LABEL: "Il doit s’agir d’un code pour votre enfant (moins de 16 ans)",
    DEPENDENT_REG_CODE_PLACEHOLDER: "ENTREZ LE CODE ICI",
    DEPENDENT_ISSUER_LABEL: "Émetteur de la carte de santé",
    DEPENDENT_ISSUER_NB: "NOUVEAU-BRUNSWICK",
    DEPENDENT_PHIN_LABEL:"Numéro d'assurance-maladie",
    DEPENDENT_PHIN_PLACEHOLDER:"999 999 999",
    DEPENDENT_FIRST_NAME_LABEL: "Prénom",
    DEPENDENT_FIRST_NAME_PLACEHOLDER: "PRÉNOM",
    DEPENDENT_LAST_NAME_LABEL: "Nom de famille",
    DEPENDENT_LAST_NAME_PLACEHOLDER: "NOM DE FAMILLE",
    DEPENDENT_EXPIRATION_LABEL: "Date d'expiration (mm/aaaa)",
    DEPENDENT_DAY: "JJ",
    DEPENDENT_MONTH: "MM",
    DEPENDENT_YEAR: "AAAA",
    DEPENDENT_DOB_LABEL: "Date de naissance (jj / mm / aaaa)",
    DEPENDENT_SUBMIT_BUTTON: "Soumettre",
    DEPENDENT_CANCEL_BUTTON: "Annuler",
    DEPENDENT_AGREE_BUTTON: "J’accepte",
    DEPENDENT_AGREEMENT_MESSAGE: "En cliquant sur « J’accepte », vous confirmez que :",
    DEPENDENT_AGREEMENT_BULLET_1: "vous êtes un parent/tuteur d’un enfant (âgé de moins de 16 ans) et vous avez le droit d’accéder aux résultats COVID-19 de cet enfant;",
    DEPENDENT_AGREEMENT_BULLET_2: "ne font pas l’objet de mesures qui feraient de vous un parent/tuteur sans droit d’accès à l’information sur cet enfant",
    DEPENDENT_AGREEMENT_BULLET_3: "comprend que l’accès à l’information en votre fonction de parent/tuteur d’un enfant (âgé de moins de 16 ans) se limite aux résultats COVID-19 dans MaSantéNB.",
    // Child Reg Info Card
    REG_INFO_LABLE: "Ajouter un enfant (moins de 16 ans)",
    REG_INFO_MESSAGE_1: "Un parent/tuteur peut ajouter un enfant s’il est âgé de moins de 16 ans.",
    REG_INFO_MESSAGE_2: "Lorsqu’un enfant atteint l’âge de 16 ans, l’accès à ses résultats ne sera plus disponible.",
    REG_INFO_MESSAGE_3: "Si l’enfant que vous ajoutez a 16 ans ou plus, il doit s’inscrire à son propre compte MaSantéNB.",
    PARENTAL_ACCESS_ALERT_HEADER: "Accès parental/tuteur seulement",
    PARENTAL_ACCESS_ALERT_BODY: "Vous avez un compte, mais vous n’avez pas fourni votre propre code d’inscription. Cela vous donne seulement ",
    PARENTAL_ACCESS_ALERT_BODY_2: "l’accès parental/tuteur",
    PARENTAL_ACCESS_ALERT_BODY_3: ". Vous pouvez ajouter les renseignements personnels sur la santé de vos enfants (moins de 16 ans) et consulter leurs informations COVID-19.",
    PARENTAL_ACCESS_ALERT_BODY_4:"Si vous avez subi un test de dépistage ou avez été vacciné contre la COVID-19, ",
    PARENTAL_ACCESS_ALERT_BODY_5:"cliquez ici, ",
    PARENTAL_ACCESS_ALERT_BODY_6:"puis sur Gérer mon compte pour accroître votre niveau d’accès et consulter vos renseignements sur la COVID-19.",
    PARENTAL_ACCESS_ALERT_ADD_ACCESS: "Ajouter un accès",
    ADD_CHILD_BTTN: "Ajouter un enfant (moins de 16 ans)",
    VIEW_RESULTS: "Voir les résultats",
    IMMUNIZATION_RECORD: "Voir les vaccinations",
    INVALID_DEPENDANT_ERROR: "Cet enfant a 16 ans ou plus et doit créer son propre compte MaSantéNB.",
    // Registration Error Messages
    REG_ERROR_INVALID_ITEM: "FR Registration failed: Invalid item",
    REG_ERROR_CREATE_USER: "FR Registration failed: Could not create user",
    REG_ERROR_MESSAGE: "FR Registration failed",
    REG_ERROR_STANDARD: "FR Error registering...",
    INCREASE_ACCESS_BUTTON_TEXT:"Ajouter un accès",
    PARENTAL_ACCESS_RESULT_BOX_HEADER: "Page d’accueil sur le COVID-19",
    BACK_TO_HOME: "Retour à l'accueil",
    VIEW_YOUR_RESULTS_HEADER: "Pour afficher vos résultats",
    VIEW_YOUR_RESULTS_BODY:"Les nouvelles dates de test s’afficheront dès que le résultat sera disponible",
    VIEW_YOUR_RESULTS_BODY_2:"Veuillez noter qu’il peut s’écouler plusieurs jours avant que les résultats des tests soient disponibles. Si vous ne les voyez pas, veuillez vérifier à nouveau plus tard.",
    VIEW_YOUR_RESULTS_BODY_3:"Vous pouvez cliquer sur le bouton « Actualiser les résultats » pour vérifier les mises à jour.",
    VIEW_YOUR_RESULTS_BODY_4: "Pour afficher les résultats du test précédent, cliquez sur le menu déroulant de la date du test et choisissez la date du test pour les résultats que vous souhaitez afficher.",
    REFRESH_RESULTS:"Rafraîchir les résultats",
    REG_ERROR_REG_NUM: "Désolé, une erreur s’est produite lors de la vérification du code d'inscription de votre enfant. Veuillez vérifier l’informations que vous avez entrées et réessayer.  Toujours en difficulté ? Contactez l’équipe de soutien",
    REG_ERROR_ISSUER: "Seules les personnes ayant un numéro d’Assurance-Maladie du Nouveau-Brunswick sont présentement admissibles à s’inscrire à un compte MaSantéNB.",
    REG_ERROR_HCN_MISSING: "Désolé, une erreur s’est produite lors de la vérification du numéro d'assurance-maladie du Nouveau-Brunswick de votre enfant. Veuillez vérifier l’information que vous avez entrées et réessayer. Toujours en difficulté ? Contactez l’équipe de soutien",
    REG_ERROR_LAST_NAME: "Désolé, une erreur s’est produite lors de la vérification du nom de votre enfant.  Veuillez vérifier l’information que vous avez entrées et réessayer. Toujours en difficulté ? Contactez l’équipe de soutien",
    REG_ERROR_EXPIRY: "Désolé, une erreur s’est produite lors de la vérification de la date d'expiration de l’assurance-maladie de votre enfant.  Veuillez vérifier l’information que vous avez entrées et réessayer. Toujours en difficulté ? Contactez L’équipe de soutien",
    REG_ERROR_DOB: "Désolé, une erreur s’est produite lors de la vérification de la date de naissance de votre enfant.  Veuillez vérifier l’information que vous avez entrées et réessayer. Toujours en difficulté ? Contactez L’équipe de soutien",
    REG_ERROR_DOB_U16: "Les personnes à charge de 16 ans ou plus doivent s’inscrire à leur propre compte MaSantéNB.",
    REG_ERROR_READD_CHILD: "L’enfant a déjà été ajouté à votre compte",
    REG_ERROR_MEDICARE_FIELD_NOT_ENOUGH_DIGITS: "La longueur du numéro d'assurance-maladie doit être de 9 chiffres",
    REG_POPUP_HEADER: "Annuler Ajouter d'un enfant (moins de 16 ans)",
    REG_POPUP_MESSAGE: "Voulez-vous annuler l’ajout d’un enfant (moins de 16 ans)?",
    REG_POPUP_CANCEL: "Non",
    REG_POPUP_CONFIRM: "Oui",
    ERROR: "Erreur",
    REG_ERROR_CHECKBOX_ERROR: "Veuillez accepter les conditions d'utilisation pour continuer",
    REG_ERROR_DOB_DAY_OUT_OF_RANGE: "La date de naissance doit être comprise entre 1 et 31",
    REG_ERROR_DOB_MONTH_OUT_OF_RANGE: "La date du mois de naissance doit être comprise entre 1 et 12",
    MEDICARE: "Numéro de carte d’assurance maladie",
    IMPORTANT_POSITIVE_MESSAGE_1: "Visitez",
    IMPORTANT_POSITIVE_MESSAGE_1B: " le site web de GNB COVID-19   ",
    IMPORTANT_POSITIVE_MESSAGE_1C: "pour les renseignements et les directives à jour.",
    COVID_MAIN_PAGE_LINK: "https://www2.gnb.ca/content/gnb/fr/corporate/promo/covid-19.html",
    SELF_ISOLATION_LINK: "https://www2.gnb.ca/content/gnb/fr/corporate/promo/covid-19/auto_isolement.html",
    DOWNLOAD_PDF:"Imprimer le PDF",
    PDF_CONFIRM_HEADER:"Avis",
    PDF_CONFIRM_MESSAGE_1:"Les utilisateurs doivent prendre note ",
    PDF_CONFIRM_MESSAGE_2:"qu’afin d’assurer les meilleurs standards d’authenticité et de permettre l’impression d’une copie officielle de résultats de test COVID-19, ",
    PDF_CONFIRM_MESSAGE_3:"MaSantéNB reçoit et met à disposition pour impression par ses utilisateurs, des informations médicales (résultats de test) dans le langage et telles qu’émises directement par le laboratoire qui les a fournies.",
    PDF_POPUP_CONFIRM:"Ok",
    PDF_POPUP_CANCEL:"Annuler",
    HCN_ISSUER: {
        NB:"NB",
        NS:"NÉ",
        DND:"FAC",
        PE:"ÎPÉ",
        NL:"TNL",
        QC:"QC",
        AB:"AB",
        BC:"CB",
        CSC:"SCC",
        CA:"CA",
        INAC:"AANC",
        MB:"MB",
        NT:"TN",
        NU:"NU",
        ON:"ON",
        RCMP:"GRC",
        SK:"SK",
        YT:"TY",
        DVA:"ACC",
    },

    // IMMUNIZATION RECORD
    IMMUNIZATIONS_HEADER: "COVID-19 - Dossier d'immunisation",
    INVALID_IMMUNIZATION_DESC_1: "FR Invalid immunization phrase 1",
    BACK_BUTTON_TEXT: "Retour à l'accueil",
    BACK_TEXT: "Retour",
    PRINT_BUTTON: "Dossier d’immunisation du N.-B.",
    PRINT_VAX_BUTTON: "Preuve canadienne de vaccination",
    IMMUNIZATIONS_NO_RESULTS_DESC: "ACTUELLEMENT, IL N'Y A AUCUN VACCINATIONS DISPONIBLE",
    IMMUNIZATIONS_SIDE_ALERT_1_1: "Cela répresente un dossier en ligne de votre immunisation contre la COVID-19. Votre ",
    IMMUNIZATIONS_SIDE_ALERT_1_2: "dossier d’immunisation contre la COVID 19",
    IMMUNIZATIONS_SIDE_ALERT_1_3: " papier, que l’on vous a remis quand vous avez reçu le vaccin, est votre dossier officiel.",
    IMMUNIZATIONS_SIDE_ALERT_2: "Le traitement des dossiers de vaccination peut prendre jusqu’à cinq jours ouvrables. Votre vaccin contre la COVID-19 s’ajoutera à la liste quand le dossier aura été traité.",
    IMMUNIZATIONS_SIDE_ALERT_3: "Nous recommandons de visiter ",
    IMMUNIZATIONS_SIDE_ALERT_3_LINK_TEXT: "le site web de GNB",
    IMMUNIZATIONS_SIDE_ALERT_3_LINK: "https://www2.gnb.ca/content/gnb/fr/corporate/promo/covid-19.html",
    IMMUNIZATIONS_SIDE_ALERT_3_2: " pour obtenir les renseignements de la COVID-19 à jour.",
    IMMUNIZATIONS_BOTTOM_ALERT_1: "Ces informations sont fournis par le registre de vaccination provincial du gouvernement du Nouveau-Brunswick dans la Solution d'information sur la santé publique (SISP). ",
    IMMUNIZATIONS_BOTTOM_ALERT_2: "Pour plus d'informations, visitez ",
    IMMUNIZATIONS_BOTTOM_ALERT_3: "la santé publique.",
    IMMUNIZATIONS_BOTTOM_ALERT_LINK: "https://www2.gnb.ca/content/gnb/fr/ministeres/bmhc/maladies_transmissibles/content/SISP.html",
    IMMUNIZATIONS_RESULTS_VACCINE_NAME: "NOM DU VACCIN",
    IMMUNIZATIONS_RESULTS_VACCINE_TYPE: "TYPE DE VACCIN",
    IMMUNIZATIONS_RESULTS_VACCINE_DATE_1: "DATE",
    IMMUNIZATIONS_RESULTS_VACCINE_DATE_2: "(AAAA-MM-JJ)",
    DEFAULT_SUPPORT_ERROR: "Désolé, un problème s'est produit. Contactez l'assistance au ",
    DEFAULT_SUPPORT_ERROR_PHONE: "1-844-462-8387",
    HIAL_DEFAULT_ERROR: "Désolé, mais nous éprouvons des difficultés techniques.  S’il vous plaît essayer à nouveau plus tard.",
    //
    VACCINE_PASSPORT: "Statut vaccinal",
    VACCINE_PASSPORT_USE_NB: "Aux fins d’utilisation au N.-B",
    VACCINE_PASSPORT_HEADER: "Statut vaccinal COVID-19",
    VACCINATION_STATUS_NA: "IMPOSSIBLE À VÉRIFIER",
    VACCINE_PASSPORT_DOB: "Date de naissance: ",
    VACCINATION_STATUS: "VÉRIFIÉ",
    VACCINATED_TEXT_ISSUED: "Délivré le: ",
    VACCINATION_X_NOTE_1: "Le traitement de l’information sur votre vaccination et la mise à jour de votre statut peut prendre jusqu’à cinq jours.",
    VACCINATION_X_NOTE_2: "Entre-temps, le dossier d’immunisation contre la COVID-19 que vous avez reçu au moment de vote vaccination est un document officiel et constitue une preuve de vaccination acceptable.",

    PDF_ERROR_MESSAGE: "Un problème technique est survenu. Veuillez contacter l'équipe de soutien au 1-844-462-8387.",
    PVC_PDF_FILENAME: "Preuve_canadienne_de_vaccination_contre_la_COVID-19_",
    QRCE_ERROR_MESSAGE: "Un problème technique est survenu. Veuillez contacter l'équipe de soutien au 1-844-462-8387.",
    IIABE_ERROR_MESSAGE: "Un problème technique est survenu. Veuillez contacter l'équipe de soutien au 1-844-462-8387.",
    SFEE_ERROR_MESSAGE: "Désolé, un problème s'est produit. Contactez l'assistance au 1-844-462-838.7",

    // TERMS OF USE SCREEN
    TERMS_OF_USE_PAGE_NAME: "Conditions d’utilisation du portail MaSantéNB COVID-19",
    TERMS_OF_USE_APP_NAME: "MaSantéNB COVID-19",
    TERMS_OF_USE_APP_DISCLAIMER_OPTIONAL_1: "Voici les conditions d’utilisation que chaque utilisateur doit lire et accepter avant de créer un nouveau compte, d’ouvrir une session pour la première fois ou d’ouvrir une session après que les conditions d’utilisation ont été modifiées. ",
    TERMS_OF_USE_APP_DISCLAIMER_OPTIONAL_2: "Vous n’avez pas à accepter les conditions d’utilisation ici. Elles sont affichées sur cette page à titre informatif uniquement.",
    TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_1: "Les conditions d’utilisation ont changé le ",
    TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_2: "21 novembre 2022",
    TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_3: ". Avant de vous connecter au portail ",
    TERMS_OF_USE_LOGIN_DISCLAIMER_CHANGED_4: " pour avoir accès à vos renseignements personnels sur la santé, vous devez lire et accepter l’intégralité des énoncés (conditions d’utilisation) ci-dessous et accepter :",
    TERMS_OF_USE_LOGIN_DISCLAIMER_1: "Avant de vous connecter au portail ",
    TERMS_OF_USE_LOGIN_DISCLAIMER_2: " pour avoir accès à vos résultats de test de dépistage de la COVID-19, à votre dossier d’immunisation et à d’importantes directives et informations relatives à la COVID-19, vous devez lire et accepter l’intégralité des énoncés (conditions d’utilisation) ci-dessous et accepter :",
    TERMS_OF_USE_ITEM_1: "de ne pas utiliser les services d’une manière qui pourrait nuire à autrui ou au système;",
    TERMS_OF_USE_ITEM_2: "de reconnaître que vous êtes toujours responsable de vos renseignements de connexion (nom d’utilisateur et mot de passe), même si vous les modifiez;",
    TERMS_OF_USE_ITEM_3: "de garder vos renseignements de connexion pour vous et de ne jamais les divulguer à d’autres personnes;",
    TERMS_OF_USE_ITEM_4: "de communiquer avec nous immédiatement au 1-844-462-8387 si vous soupçonnez que vos renseignements de connexion ont été utilisés par une autre personne;",
    TERMS_OF_USE_ITEM_5: "de ne pas utiliser les renseignements de connexion d’une autre personne à des fins illégales ou incorrectes;",
    TERMS_OF_USE_ITEM_6_1: "que CyberSantéNB vérifie et surveille l’accès au portail ",
    TERMS_OF_USE_ITEM_6_2: ";",
    TERMS_OF_USE_ITEM_7_1: "que votre accès à ",
    TERMS_OF_USE_ITEM_7_2: " puisse être suspendu ou supprimé s’il est utilisé de manière inappropriée;",
    TERMS_OF_USE_ITEM_8_1: "que Santé publique puisse vérifier que vous avez consulté vos résultats de test de dépistage de la COVID-19 et votre dossier d’immunisation contre la COVID-19 par l’intermédiaire du portail ",
    TERMS_OF_USE_ITEM_8_2: ";",
    TERMS_OF_USE_ITEM_9_1: " que, lorsqu’ils sont accessibles, les renseignements sur votre enfant de moins de 16 ans et dont vous êtes le tuteur légal soient restreints aux renseignements sur la COVID-19 accessibles par l’intermédiaire du portail ",
    TERMS_OF_USE_ITEM_9_2: ";",
    TERMS_OF_USE_ITEM_10_1: "de ne pas utiliser les services pour accéder aux résultats de test de dépistage de la COVID-19 ni au dossier d’immunisation contre la COVID-19 de votre enfant âgé de 16 ans ou plus par l’intermédiaire du portail ",
    TERMS_OF_USE_ITEM_10_2: ";",
    TERMS_OF_USE_ITEM_11_1: "que Santé publique puisse vérifier que vous avez accédé aux résultats de test de dépistage de la COVID-19 et au dossier d’immunisation contre la COVID-19 de votre enfant de moins de 16 ans à titre de parent ou tuteur par l’intermédiaire du portail ",
    TERMS_OF_USE_ITEM_11_2: ", lorsque ces renseignements sont accessibles;",
    TERMS_OF_USE_ACCEPT_BUTTON: "Accepter",
    TERMS_OF_USE_CANCEL_BUTTON: "Annuler",

    TERMS_OF_USE_SIDE_LINK_1: "",
    TERMS_OF_USE_SIDE_LINK_2: "Conditions d’utilisation",
    TERMS_OF_USE_SIDE_LINK_3: " de MaSantéNB COVID-19.",
}
